import { render, staticRenderFns } from "./edit_class_view.vue?vue&type=template&id=7ea846fa&"
import script from "./edit_class_view.vue?vue&type=script&lang=js&"
export * from "./edit_class_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports